import axios from "axios"
import { BASE_API_URL } from "../constants/dropdown"

// Action Types
export const GET_REFERRAL_ANALYTICS_REQUEST = "GET_REFERRAL_ANALYTICS_REQUEST"
export const GET_REFERRAL_ANALYTICS_SUCCESS = "GET_REFERRAL_ANALYTICS_SUCCESS"
export const GET_REFERRAL_ANALYTICS_FAIL = "GET_REFERRAL_ANALYTICS_FAIL"

export const GET_REFERRAL_REFERRERS_REQUEST = "GET_REFERRAL_REFERRERS_REQUEST"
export const GET_REFERRAL_REFERRERS_SUCCESS = "GET_REFERRAL_REFERRERS_SUCCESS"
export const GET_REFERRAL_REFERRERS_FAIL = "GET_REFERRAL_REFERRERS_FAIL"

export const GET_REFERRAL_LEADERBOARD_REQUEST = "GET_REFERRAL_LEADERBOARD_REQUEST"
export const GET_REFERRAL_LEADERBOARD_SUCCESS = "GET_REFERRAL_LEADERBOARD_SUCCESS"
export const GET_REFERRAL_LEADERBOARD_FAIL = "GET_REFERRAL_LEADERBOARD_FAIL"

export const GET_REFERRER_DETAIL_REQUEST = "GET_REFERRER_DETAIL_REQUEST"
export const GET_REFERRER_DETAIL_SUCCESS = "GET_REFERRER_DETAIL_SUCCESS"
export const GET_REFERRER_DETAIL_FAIL = "GET_REFERRER_DETAIL_FAIL"

export const GET_REFERRAL_DETAIL_REQUEST = "GET_REFERRAL_DETAIL_REQUEST"
export const GET_REFERRAL_DETAIL_SUCCESS = "GET_REFERRAL_DETAIL_SUCCESS"
export const GET_REFERRAL_DETAIL_FAIL = "GET_REFERRAL_DETAIL_FAIL"

export const GET_REFERRAL_LINK_REQUEST = "GET_REFERRAL_LINK_REQUEST"
export const GET_REFERRAL_LINK_SUCCESS = "GET_REFERRAL_LINK_SUCCESS"
export const GET_REFERRAL_LINK_FAIL = "GET_REFERRAL_LINK_FAIL"

export const GET_STAFF_LEADERBOARD_REQUEST = "GET_STAFF_LEADERBOARD_REQUEST"
export const GET_STAFF_LEADERBOARD_SUCCESS = "GET_STAFF_LEADERBOARD_SUCCESS"
export const GET_STAFF_LEADERBOARD_FAIL = "GET_STAFF_LEADERBOARD_FAIL"

export const GET_REFERRAL_STATES_REQUEST = "GET_REFERRAL_STATES_REQUEST"
export const GET_REFERRAL_STATES_SUCCESS = "GET_REFERRAL_STATES_SUCCESS"
export const GET_REFERRAL_STATES_FAIL = "GET_REFERRAL_STATES_FAIL"

// Helper to get auth config
const getConfig = (getState) => {
  const {
    admin2faLogin: { userInfo }
  } = getState()
  const token = userInfo?.token?.access_token
  return {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    }
  }
}

// Fetch referral analytics
export const fetchReferralAnalytics =
  (fromDate = "") =>
  async (dispatch, getState) => {
    try {
      dispatch({ type: GET_REFERRAL_ANALYTICS_REQUEST })
      const config = getConfig(getState)
      const query = fromDate ? `?fromDate=${fromDate}` : ""
      const { data } = await axios.get(
        `${BASE_API_URL}/admin/referrals/analytics${query}`,
        config
      )
      dispatch({ type: GET_REFERRAL_ANALYTICS_SUCCESS, payload: data })
    } catch (error) {
      dispatch({
        type: GET_REFERRAL_ANALYTICS_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message
      })
    }
  }

// Fetch referrers list
export const fetchReferrers =
  (page = 1, pageSize = 10, fromDate = "") =>
  async (dispatch, getState) => {
    try {
      dispatch({ type: GET_REFERRAL_REFERRERS_REQUEST })
      const config = getConfig(getState)
      const { data } = await axios.get(
        `${BASE_API_URL}/admin/referrals/referrers?page=${page}&pageSize=${pageSize}${fromDate ? `&fromDate=${fromDate}` : ""}`,
        config
      )
      dispatch({ type: GET_REFERRAL_REFERRERS_SUCCESS, payload: data })
    } catch (error) {
      dispatch({
        type: GET_REFERRAL_REFERRERS_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message
      })
    }
  }

// Fetch leaderboard
export const fetchReferralLeaderboard =
  (page = 1, pageSize = 10, fromDate = "") =>
  async (dispatch, getState) => {
    try {
      dispatch({ type: GET_REFERRAL_LEADERBOARD_REQUEST })
      const config = getConfig(getState)
      const { data } = await axios.get(
        `${BASE_API_URL}/admin/referrals/leaderboard?page=${page}&pageSize=${pageSize}${fromDate ? `&fromDate=${fromDate}` : ""}`,
        config
      )
      dispatch({ type: GET_REFERRAL_LEADERBOARD_SUCCESS, payload: data })
    } catch (error) {
      dispatch({
        type: GET_REFERRAL_LEADERBOARD_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message
      })
    }
  }

// Fetch single referrer detail (with their referrals list)
export const fetchReferrerDetail =
  (referrerId) => async (dispatch, getState) => {
    try {
      dispatch({ type: GET_REFERRER_DETAIL_REQUEST })
      const config = getConfig(getState)
      const { data } = await axios.get(
        `${BASE_API_URL}/admin/referrals/${referrerId}`,
        config
      )
      dispatch({ type: GET_REFERRER_DETAIL_SUCCESS, payload: data })
    } catch (error) {
      dispatch({
        type: GET_REFERRER_DETAIL_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message
      })
    }
  }

// Fetch single referral detail
export const fetchReferralDetail =
  (referrerId, refereeId) => async (dispatch, getState) => {
    try {
      dispatch({ type: GET_REFERRAL_DETAIL_REQUEST })
      const config = getConfig(getState)
      const { data } = await axios.get(
        `${BASE_API_URL}/admin/referrals/${referrerId}/${refereeId}`,
        config
      )
      dispatch({ type: GET_REFERRAL_DETAIL_SUCCESS, payload: data })
    } catch (error) {
      dispatch({
        type: GET_REFERRAL_DETAIL_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message
      })
    }
  }

  // Fetch referral link by referrer tag
export const fetchReferralLink =
  (referrerTag) => async (dispatch, getState) => {
    try {
      dispatch({ type: GET_REFERRAL_LINK_REQUEST })
      const config = getConfig(getState)
      const { data } = await axios.get(
        `${BASE_API_URL}/admin/referrals/link?referrerTag=${referrerTag}`,
        config
      )
      dispatch({ type: GET_REFERRAL_LINK_SUCCESS, payload: data })
    } catch (error) {
      dispatch({
        type: GET_REFERRAL_LINK_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message
      })
    }
  }

// Fetch staff leaderboard
export const fetchStaffLeaderboard =
  (page = 1, pageSize = 10, fromDate = "") =>
  async (dispatch, getState) => {
    try {
      dispatch({ type: GET_STAFF_LEADERBOARD_REQUEST })
      const config = getConfig(getState)
      const { data } = await axios.get(
        `${BASE_API_URL}/admin/referrals/leaderboard/staff?page=${page}&pageSize=${pageSize}${fromDate ? `&fromDate=${fromDate}` : ""}`,
        config
      )
      dispatch({ type: GET_STAFF_LEADERBOARD_SUCCESS, payload: data })
    } catch (error) {
      dispatch({
        type: GET_STAFF_LEADERBOARD_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message
      })
    }
  }

// Fetch referral states
export const fetchReferralStates = () => async (dispatch, getState) => {
  try {
    dispatch({ type: GET_REFERRAL_STATES_REQUEST })
    const config = getConfig(getState)
    const { data } = await axios.get(
      `${BASE_API_URL}/admin/referrals/state`,
      config
    )
    dispatch({ type: GET_REFERRAL_STATES_SUCCESS, payload: data })
  } catch (error) {
    dispatch({
      type: GET_REFERRAL_STATES_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message
    })
  }
}